import { renderToast, ToastType } from '@inwink/toaster';
import type { Entities } from '@inwink/entities/entities';
import {translate} from '@@services/i18nservice';

let defaultI18nHelper: Entities.i18nHelper;
export function registerI18nHelper(i18n: Entities.i18nHelper) {
    defaultI18nHelper = i18n;
}

function toast(key: string,
    type: ToastType,
    service: Entities.i18nService,
    inject?: any,
    timeout?: number) {
    let label = key;
    if (defaultI18nHelper) {
        label = defaultI18nHelper.translate(key, inject);
    } else if (service) {
        label = translate(service, key, inject);
    }
    if (!label) {
        if (type === "success") {
            label = "Success.";
        } else if (type === "error") {
            label = "An error has occured.";
        }
    }
    return renderToast(label, type, null, false, timeout);
}

export function toastSuccess(service: Entities.i18nService,
    key: string,
    inject?: any,
    timeout?: number) {
    return toast(key, 'success', service, inject, timeout);
}

export function toastError(service: Entities.i18nService,
    label: string,
    inject?: any,
    timeout?: number) {
    return toast(label, 'error', service, inject, timeout);
}

export function toastWarning(service: Entities.i18nService,
    label: string,
    inject?: any,
    timeout?: number) {
    return toast(label, 'warning', service, inject, timeout);
}

export function toastInfo(service: Entities.i18nService,
    label: string,
    inject?: any,
    timeout?: number) {
    return toast(label, 'info', service, inject, timeout);
}


export function showBetaFeatures() {
    if (inwink.config.isBetaEnv) {
        return true;
    }

    const overrideShowBeta = localStorage.getItem("showBetaFeatures");
    if (overrideShowBeta) {
        return overrideShowBeta === "true";
    }
    return inwink.config.showBetaFeatures;
}